export const ACCOUNTING_HAS_ERRORED = '[Accounting] ACCOUNTING_HAS_ERRORED'
export type ACCOUNTING_HAS_ERRORED = typeof ACCOUNTING_HAS_ERRORED

/** SPONSOR AND PTC */
export const GET_INVOICE_YEARS = '[Accounting] GET_INVOICE_YEARS'
export type GET_INVOICE_YEARS = typeof GET_INVOICE_YEARS

export const GET_INVOICE_YEARS_SUCCESS = '[Accounting] GET_INVOICE_YEARS_SUCCESS'
export type GET_INVOICE_YEARS_SUCCESS = typeof GET_INVOICE_YEARS_SUCCESS

export const GET_PAGINATED_INVOICES = '[Accounting] GET_PAGINATED_INVOICES'
export type GET_PAGINATED_INVOICES = typeof GET_PAGINATED_INVOICES

export const GET_PAGINATED_INVOICES_SUCCESS = '[Accounting] GET_PAGINATED_INVOICES_SUCCESS'
export type GET_PAGINATED_INVOICES_SUCCESS = typeof GET_PAGINATED_INVOICES_SUCCESS

export const SET_PAGINATED_INVOICES_ACTIVE_PAGE = '[Accounting] SET_PAGINATED_INVOICES_ACTIVE_PAGE'
export type SET_PAGINATED_INVOICES_ACTIVE_PAGE = typeof SET_PAGINATED_INVOICES_ACTIVE_PAGE

export const CREATE_INVOICE = '[Accounting] CREATE_INVOICE'
export type CREATE_INVOICE = typeof CREATE_INVOICE

export const CREATE_INVOICE_SUCCESS = '[Accounting] CREATE_INVOICE_SUCCESS'
export type CREATE_INVOICE_SUCCESS = typeof CREATE_INVOICE_SUCCESS

export const UPDATE_INVOICE = '[Accounting] UPDATE_INVOICE'
export type UPDATE_INVOICE = typeof UPDATE_INVOICE

export const UPDATE_INVOICE_SUCCESS = '[Accounting] UPDATE_INVOICE_SUCCESS'
export type UPDATE_INVOICE_SUCCESS = typeof UPDATE_INVOICE_SUCCESS

export const DELETE_INVOICE = '[Accounting] DELETE_INVOICE'
export type DELETE_INVOICE = typeof DELETE_INVOICE

export const DELETE_INVOICE_SUCCESS = '[Accounting] DELETE_INVOICE_SUCCESS'
export type DELETE_INVOICE_SUCCESS = typeof DELETE_INVOICE_SUCCESS

export const GET_INVOICE = '[Accounting] GET_INVOICE'
export type GET_INVOICE = typeof GET_INVOICE

export const GET_INVOICE_SUCCESS = '[Accounting] GET_INVOICE_SUCCESS'
export type GET_INVOICE_SUCCESS = typeof GET_INVOICE_SUCCESS

export const SET_SELECTED_INVOICE = '[Accounting] SET_SELECTED_INVOICE'
export type SET_SELECTED_INVOICE = typeof SET_SELECTED_INVOICE

export const GET_ACCOUNTING_CHART_DATA = '[Accounting] GET_ACCOUNTING_CHART_DATA'
export type GET_ACCOUNTING_CHART_DATA = typeof GET_ACCOUNTING_CHART_DATA

export const GET_ACCOUNTING_CHART_DATA_SUCCESS = '[Accounting] GET_ACCOUNTING_CHART_DATA_SUCCESS'
export type GET_ACCOUNTING_CHART_DATA_SUCCESS = typeof GET_ACCOUNTING_CHART_DATA_SUCCESS

/** DC */
export const GET_PAGINATED_DC_INVOICES = '[Accounting] GET_PAGINATED_DC_INVOICES'
export type GET_PAGINATED_DC_INVOICES = typeof GET_PAGINATED_DC_INVOICES

export const GET_PAGINATED_DC_INVOICES_SUCCESS = '[Accounting] GET_PAGINATED_DC_INVOICES_SUCCESS'
export type GET_PAGINATED_DC_INVOICES_SUCCESS = typeof GET_PAGINATED_DC_INVOICES_SUCCESS

export const SET_PAGINATED_DC_INVOICES_ACTIVE_PAGE = '[Accounting] SET_PAGINATED_DC_INVOICES_ACTIVE_PAGE'
export type SET_PAGINATED_DC_INVOICES_ACTIVE_PAGE = typeof SET_PAGINATED_DC_INVOICES_ACTIVE_PAGE

export const CREATE_DC_INVOICE = '[Accounting] CREATE_DC_INVOICE'
export type CREATE_DC_INVOICE = typeof CREATE_DC_INVOICE

export const CREATE_DC_INVOICE_SUCCESS = '[Accounting] CREATE_DC_INVOICE_SUCCESS'
export type CREATE_DC_INVOICE_SUCCESS = typeof CREATE_DC_INVOICE_SUCCESS

export const UPDATE_DC_INVOICE = '[Accounting] UPDATE_DC_INVOICE'
export type UPDATE_DC_INVOICE = typeof UPDATE_DC_INVOICE

export const UPDATE_DC_INVOICE_SUCCESS = '[Accounting] UPDATE_DC_INVOICE_SUCCESS'
export type UPDATE_DC_INVOICE_SUCCESS = typeof UPDATE_DC_INVOICE_SUCCESS

export const DELETE_DC_INVOICE = '[Accounting] DELETE_DC_INVOICE'
export type DELETE_DC_INVOICE = typeof DELETE_DC_INVOICE

export const DELETE_DC_INVOICE_SUCCESS = '[Accounting] DELETE_DC_INVOICE_SUCCESS'
export type DELETE_DC_INVOICE_SUCCESS = typeof DELETE_DC_INVOICE_SUCCESS

export const GET_DC_INVOICE = '[Accounting] GET_DC_INVOICE'
export type GET_DC_INVOICE = typeof GET_DC_INVOICE

export const GET_DC_INVOICE_SUCCESS = '[Accounting] GET_DC_INVOICE_SUCCESS'
export type GET_DC_INVOICE_SUCCESS = typeof GET_DC_INVOICE_SUCCESS

export const SET_SELECTED_DC_INVOICE = '[Accounting] SET_SELECTED_DC_INVOICE'
export type SET_SELECTED_DC_INVOICE = typeof SET_SELECTED_DC_INVOICE

export const GET_ACCOUNTING_RECEIPTS_CHART_DATA = '[Accounting] GET_ACCOUNTING_RECEIPTS_CHART_DATA'
export type GET_ACCOUNTING_RECEIPTS_CHART_DATA = typeof GET_ACCOUNTING_RECEIPTS_CHART_DATA

export const GET_ACCOUNTING_RECEIPTS_CHART_DATA_SUCCESS = '[Accounting] GET_ACCOUNTING_RECEIPTS_CHART_DATA_SUCCESS'
export type GET_ACCOUNTING_RECEIPTS_CHART_DATA_SUCCESS = typeof GET_ACCOUNTING_RECEIPTS_CHART_DATA_SUCCESS

/** ALL */
export const SET_PERIOD_TYPE = '[Accounting] SET_PERIOD_TYPE'
export type SET_PERIOD_TYPE = typeof SET_PERIOD_TYPE

export const SET_SELECTED_YEAR = '[Accounting] SET_SELECTED_YEAR'
export type SET_SELECTED_YEAR = typeof SET_SELECTED_YEAR

export const SELECT_TAB = '[Accounting] SELECT_TAB'
export type SELECT_TAB = typeof SELECT_TAB
